module.exports = __webpack_public_path__ + "img/graphic-land-mix.14cdca99.png";